let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eZCIf")).then(() => parcelRequire('8gBj2'));